import { render, staticRenderFns } from "./multidamageForm.pug?vue&type=template&id=6569874f&lang=pug&"
import script from "./multidamageForm.js?vue&type=script&lang=js&"
export * from "./multidamageForm.js?vue&type=script&lang=js&"
import style0 from "./multidamageForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6569874f')) {
      api.createRecord('6569874f', component.options)
    } else {
      api.reload('6569874f', component.options)
    }
    module.hot.accept("./multidamageForm.pug?vue&type=template&id=6569874f&lang=pug&", function () {
      api.rerender('6569874f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/multidamageForm/index.vue"
export default component.exports